import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import { selectors } from '../reducers/portaliLandingPage';
import routeRegister from '../../../helpers/routeRegister';
import { generateRoutes } from '../../../helpers/portaleModuleHelper';

const routes = generateRoutes('landingPage', selectors);
const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'portaliLandingPage' */ `modules/portaliLandingPage/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliLandingPage', routes.patterns);
routeRegister.addLinks('portaliLandingPage', links);

export default list;
